function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#0082FF",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  strokeMiterlimit: 4,
  strokeWidth: 1.2,
  d: "M5.922 8.060l2.821 2.821 10.345-10.345"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#0082FF",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  strokeMiterlimit: 4,
  strokeWidth: 1.2,
  d: "M17.476 9v6.583c0 1.039-0.842 1.881-1.881 1.881v0h-13.166c-1.039 0-1.881-0.842-1.881-1.881v0-13.166c0-1.039 0.842-1.881 1.881-1.881v0h10.345"
});

var SvgIcoCheck = function SvgIcoCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-check.70d0b6fb.svg";
export { ForwardRef as ReactComponent };